/* global axios */
import ApiClient from './ApiClient';

class PipelinesAPI extends ApiClient {
  constructor() {
    super('pipelines', { accountScoped: true, apiVersion: 'v2' });
  }

  fromTemplate(payload) {
    return axios.post(`${this.url}/from_template`, payload);
  }

  reorderStages(pipelineId, positions) {
    return axios.patch(`${this.url}/${pipelineId}/reorder_stages`, { positions });
  }
}

export default new PipelinesAPI();
